module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAeCAMAAAD95QUdAAAANlBMVEUAAACU0/Km2f+V0vOS1fqU0fKU0/OU0vOU0vKU0vOV0/OU0/OU0/OT0fOZ3f+V0vOU0vKU0vJtdmVMAAAAEXRSTlMA7QXWCvbo497Nx7+4ew+wsHcrEW0AAABUSURBVCjPndJHDsAgDERRE9I7979s4uXoIxB4+SQXjWxXmkwr/aUSemkmLaSVFJ2GGm2k3WkUOkin0y304ohHBF2czO28MGYBaSCxYqqhHQzAT/gAF3QInCHgr8oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/password/forgetarr.png
// module id = 5Jy2
// module chunks = 1